import React, { useRef, useState } from "react";
import ButtonDropdown from "@amzn/awsui-components-react/polaris/button-dropdown";
import removeMarkdown from "remove-markdown";
import styles from "./style.module.scss";

interface MessageCopyButtonProps {
  content: string;
}

const MessageCopyButton: React.FC<MessageCopyButtonProps> = ({ content }) => {
  const [copied, setCopied] = useState(false);
  const containerRef = useRef<HTMLDivElement>(null);

  const showCopied = () => {
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  const handleCopyFormatted = () => {
    const el = containerRef.current
      ?.closest(`.${styles.messageContent}`)
      ?.querySelector("[data-copy-target]");

    if (el) {
      const html = el.innerHTML;
      const blob = new Blob([html], { type: "text/html" });
      const textBlob = new Blob([content], { type: "text/plain" });
      navigator.clipboard
        .write([
          new ClipboardItem({ "text/html": blob, "text/plain": textBlob }),
        ])
        .then(showCopied);
    } else {
      navigator.clipboard.writeText(content).then(showCopied);
    }
  };

  const handleCopyPlainText = () => {
    navigator.clipboard.writeText(removeMarkdown(content)).then(showCopied);
  };

  return (
    <div
      ref={containerRef}
      className={`${styles.messageCopyWrapper} ${copied ? styles.messageCopied : ""}`}
    >
      <ButtonDropdown
        items={[
          { id: "formatted", text: "Copy as formatted" },
          { id: "plain-text", text: "Copy as plain text" },
        ]}
        onItemClick={({ detail }) => {
          if (detail.id === "formatted") {
            handleCopyFormatted();
          } else if (detail.id === "plain-text") {
            handleCopyPlainText();
          }
        }}
        variant="normal"
      >
        {copied ? "Copied!" : "Copy"}
      </ButtonDropdown>
    </div>
  );
};

export default MessageCopyButton;
